import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeslaComponent } from './simple-icons-tesla.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeslaComponent ],
    exports:      [ SimpleIconsTeslaComponent ],
    bootstrap:    []
})
export class SimpleIconsTeslaModule {}
